<template>
  <div class="image-grid-container">
    <div class="image-grid">
      <div class="image-item" v-for="(image, index) in allImages" :key="index">
        <img :src="image" :alt="'Image ' + (index + 1)" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageGrid",
  data() {
    return {
      allImages: [
        require('@/assets/image/index/1.png'),
        require('@/assets/image/index/2.png'),
        require('@/assets/image/index/3.png'),
        require('@/assets/image/index/4.png'),
        require('@/assets/image/index/5.png'),
        require('@/assets/image/index/6.png'),
      ]
    };
  }
};
</script>

<style scoped>
.image-grid-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-grid {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 0.5%; /* 图片之间的间隙 */
}

.image-item {
  width: 33%; /* 100% / 3 - 间隙 */
  height: 17vw;
  /* aspect-ratio: 1; /* 保持正方形 */
  text-align: center;
  /* border: 1px solid red; */
  margin-bottom: 0.5vw;
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .image-item {
    width: 100%; /* 移动端每行显示2个 */
    height: 50vw;
    margin-bottom: 8px;

  }
}


</style>
